var eventMgr = require('../common/eventMgr');
var util = require('../common/util');

var initialized = false;
var resolveGMapsFn;
var resolveLocationFn;
var rejectLocationFn;
var geocoder;
var googleMaps;
var infowindow;
var initializationPromise = new Promise((resolve) => {
    resolveGMapsFn = resolve;
});
var locationPromise = new Promise((resolve, reject) => {
    resolveLocationFn = resolve;
    rejectLocationFn = reject;
});


window.gMapsCallback = () => {
    googleMaps = window.google.maps;
    geocoder = new googleMaps.Geocoder();
    resolveGMapsFn();
};

const googleServises = {
    getGoogleAPI: ({ apiKey, googleApiLibraries }) => {
        if (initialized === false) {
            let url = 'https://maps.googleapis.com/maps/api/js';
            url = util.appendParamsToUrl(url, {
                key: apiKey,
                libraries: googleApiLibraries || 'geometry',
                callback: 'gMapsCallback'
            });

            let script = document.createElement('script');
            script.src = url;
            script.type = 'text/javascript';
            $('body').append(script);

            initialized = true;
        }
        return initializationPromise;
    },
    initMap: (params) => {
        return googleServises.getGoogleAPI({
            apiKey: params.apiKey,
            googleApiLibraries: params.googleApiLibraries
        }).then(() => {
            return new googleMaps.Map(params.$el, {
                center: { lat: params.lat, lng: params.lng },
                zoom: 14,
                fullscreenControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                zoomControlOptions: {
                    position: googleMaps.ControlPosition.RIGHT_TOP
                }
            });
        });
    },
    createMarkers: (params) => {
        return new Promise((resolve) => {
            var marker = new googleMaps.Marker({
                position: new googleMaps.LatLng(params.lat, params.lng),
                map: params.map,
                icon: {
                    url: params.icon,
                    scaledSize: new googleMaps.Size(35, 35)
                },
                title: params.title
            });
            resolve(marker);
        });
    },
    createMarkersInfoWindow: (params) => {
        return new Promise((resolve) => {
            var contentString =
                `<div>
                    <div class="shipping-location-results-title">${params.point.nom}</div>
                    <a class="shipping-location-results-link" target="_blank" href="${params.point.storeDirectionLink}">
                        <p>${params.point.adresse1}</p>
                        <p>${params.point.codePostal}</p>
                        <p>${params.point.localite}</p>
                    </a>
                </div>`;

            if (infowindow) {
                infowindow.close();
            }
            infowindow = new googleMaps.InfoWindow({
                content: contentString
            });
            infowindow.open(params.map, params.marker);
            resolve(infowindow);
        });
    },
    initAutocomplete: (params) => {
        return Promise.resolve(new googleMaps.places.Autocomplete(params.input, params.options));
    },
    successLocation: (params) => {
        return resolveLocationFn(params.coords);
    },
    notAllowed: () => {
        return rejectLocationFn({ isGeolocationDisabled: true });
    },
    geoLocation: () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(googleServises.successLocation, googleServises.notAllowed, { timeout: 5000 });
        } else {
            googleServises.notAllowed();
        }
    },
    getUserLocation: () => {
        googleServises.geoLocation();
        return locationPromise;
    },
    getSearchParam: (params) => {
        let options = {};

        if (params.value) {
            options.address = params.value;
        }
        if (params.address) {
            options.address = params.address;
        }
        if (params.latitude || params.longitude) {
            options.location = {
                lat: params.latitude,
                lng: params.longitude
            };
        }
        if (params.componentRestrictions) {
            options.componentRestrictions = params.componentRestrictions;
        }
        return options;
    },
    getGeocode: (params) => {
        return new Promise((resolve, reject) => {
            var searchParam = googleServises.getSearchParam(params);
            geocoder.geocode(searchParam, (results, status) => {
                if (status === googleMaps.GeocoderStatus.OK) {
                    resolve(results);
                } else {
                    reject(status);
                }
            });
        });
    },
    getNewBounds: () => {
        return Promise.resolve(new googleMaps.LatLngBounds());
    },
    getDistance: (params) => {
        var startPoint = new googleMaps.LatLng(params.startLat, params.startLng);
        var storePoint = new googleMaps.LatLng(params.storeLat, params.storeLng);
        return Promise.resolve(googleMaps.geometry.spherical.computeDistanceBetween(startPoint, storePoint));
    },
    parseAddress: function (response) {
        var findTypeValue = (...types) => {
            return types.map((type) => {
                var value = response.find((item) => {
                    if (~item.types.indexOf(type)) {
                        return item;
                    }
                    return null;
                });
                if (type === 'country') {
                    return value ? value.short_name : '';
                }
                return value ? value.long_name : '';
            }).filter(component => component).join(' ');
        };

        return Promise.resolve({
            address1: findTypeValue('street_number', 'route'),
            city: findTypeValue('postal_town', 'locality'),
            county: findTypeValue('administrative_area_level_2'),
            postalCode: findTypeValue('postal_code'),
            countryCode: findTypeValue('country')
        });
    },
    getAddress: function (params) {
        return googleServises.getGeocode(params).then((response) => {
            return googleServises.parseAddress(response[0].address_components);
        });
    }
};

/**
 * @function
 * @description Creating google events and return promise after creating
 * @returns {Promise}
 **/
function initGoogleEvents() {
    return new Promise((resolve) => {
        eventMgr.registerAction('google.api', googleServises.getGoogleAPI);
        eventMgr.registerAction('google.init.map', googleServises.initMap);
        eventMgr.registerAction('google.create.markers', googleServises.createMarkers);
        eventMgr.registerAction('google.init.autocomplete', googleServises.initAutocomplete);
        eventMgr.registerAction('google.get.user.location', googleServises.getUserLocation);
        eventMgr.registerAction('google.geocode', googleServises.getGeocode);
        eventMgr.registerAction('google.new.bounds', googleServises.getNewBounds);
        eventMgr.registerAction('google.get.distance', googleServises.getDistance);
        eventMgr.registerAction('google.address.lookup', googleServises.getAddress);
        eventMgr.registerAction('google.address.parse', googleServises.parseAddress);
        eventMgr.registerAction('google.create.marker.window', googleServises.createMarkersInfoWindow);
        return resolve();
    });
}


module.exports = initGoogleEvents;
